module.exports = "/images/7eb92567584c4210f257b022c3de0e9f.png";